import { randNumber, randCompanyName, randAccount, randStateAbbr, randAirportCode } from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { Account } from '../account';

export class MockAccount extends Account {
   constructor() {
      super();

      this.id = randNumber();
      this.name = randCompanyName();
      if ( optional() ) { this.accountNumber = +randAccount(); }
      if ( optional() ) { this.stationCode = randStateAbbr() + randNumber({ min: 10, max: 99 }) + randAirportCode(); }
      this.primary = false;
      this.active = false;
      this.pinned = optional();
   }
}
